var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 399 292",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.147 197.307c0-46.185 28.37-76.069 71.897-76.069s71.897 29.884 71.897 76.069c0 43.081-29.536 72.965-71.897 72.965-41.972 0-71.897-29.884-71.897-72.965zm76.561-175.813c33.033 0 57.517 15.524 62.569 48.514h25.65C188.875 29.644 160.116.148 109.594.148 28.37.148 0 68.455 0 156.944c0 84.996 31.48 134.674 101.044 134.674 59.461 0 97.547-42.692 97.547-95.475 0-55.888-38.863-96.251-94.826-96.251-37.309 0-66.456 18.629-79.281 45.021 0-81.115 31.868-123.419 81.224-123.419zM393.171 77.77h-27.205l-57.906 81.115-57.906-81.115h-28.759l72.286 101.296-76.561 107.507h27.982l62.181-88.101 63.347 88.101H399L321.662 178.29l71.509-100.52z",
    fill: "#C23F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6X);
export default __webpack_public_path__ + "static/media/6x.b75d496ea96d9ab42d06cbc883a9655b.svg";
export { ForwardRef as ReactComponent };